import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

import { useOidcAuth } from '@/features/login/model/use-oidc-auth';
import { OidcProvider } from '@/shared/config/oidc-config';

export const WFPUsersSection = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const fromLocal = location.state?.from;
  const returnUrl = fromLocal ? `${fromLocal.pathname}${fromLocal.search}${fromLocal.hash}` : undefined;

  const { loginWithRedirect, isLoading } = useOidcAuth(OidcProvider.AZURE);

  return (
    <Card>
      <CardHeader className="text-center">
        <CardTitle data-testid="wfp-users-section-title" className="text-lg">
          {t('login.screen.wfp.login.panel.title')}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <Button className="w-full" size="lg" onClick={() => loginWithRedirect(returnUrl)} disabled={isLoading}>
          {isLoading ? t('login.loggingin.message') : t('login.user.button')}
        </Button>
      </CardContent>
    </Card>
  );
};
